module.exports = __webpack_public_path__ + "img/rhombus-purple.ec95ec28.svg";